import React from "react";
import "./CustomModal.css";
import { CustomModal } from "./CustomModal";

// Was a docked, non-blocking panel on wide viewports (see git history) -
// reverted to plain CustomModal on every viewport, wide included, per user
// request ("глюки" - the docked/pick-and-drop-a-candidate flow it enabled
// had enough rough edges that a plain blocking modal, closed explicitly via
// its own X after a pick, is preferred here). BottomSheetPanel.jsx (the
// matches-viewing sheet) is a separate component and unaffected by this -
// this reverts participant/match *adding* only.
// `header` lets a caller (e.g. ScheduleSelectMatchModal) put its own
// title/search/tabs block inline before `children`, same spot `title` would
// otherwise render one - CustomModal has no separate title zone of its own.
export const ParticipantPickerPanel = ({ isOpen, onClose, centered = true, header, children }) => (
    <CustomModal isOpen={isOpen} onClose={onClose} centered={centered}>
        {header}
        {children}
    </CustomModal>
);
